import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const Organization = () => {
  return (
    <div className="container flex flex-col gap-6">
      <div>
        <p className="text-xl font-semibold">Organization</p>
        <p className="text-sm text-muted-foreground">
          Manage your organization structure and permissions
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {/* Fine-Grained Access Control */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Fine-Grained Access Control</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-3 text-sm text-muted-foreground">
              Workspace-level permissions
            </p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                <span><strong>Read</strong> - View workspace resources</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                <span><strong>Write</strong> - Create/modify resources</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                <span><strong>Bill</strong> - Access billing information</span>
              </li>
            </ul>
            <div className="mt-4">
              <span className="rounded-full bg-muted px-2 py-1 text-xs text-muted-foreground">
                Coming soon
              </span>
            </div>
          </CardContent>
        </Card>

        {/* Resource Management */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Resource Management</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-3 text-sm text-muted-foreground">
              Inherited quota management
            </p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                <span><strong>Grant Quota</strong> - Allocate resources to members</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                <span><strong>Manage Quota</strong> - Adjust resource limits</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                <span><strong>View</strong> - Monitor usage</span>
              </li>
            </ul>
            <div className="mt-4">
              <span className="rounded-full bg-muted px-2 py-1 text-xs text-muted-foreground">
                Coming soon
              </span>
            </div>
          </CardContent>
        </Card>

        {/* Nested Groups */}
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Nested Groups</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-3 text-sm text-muted-foreground">
              Role hierarchy up to 5 levels
            </p>
            <ol className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-xs">1</span>
                <span>Resource Owner</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-xs">2</span>
                <span>Department</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-xs">3</span>
                <span>Developer</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-xs">4</span>
                <span>Contractor</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-xs">5</span>
                <span>Admin</span>
              </li>
            </ol>
            <div className="mt-4">
              <span className="rounded-full bg-muted px-2 py-1 text-xs text-muted-foreground">
                Coming soon
              </span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Organization;
